import React, { Component } from 'react'
import { connect } from 'react-redux'

import Button from '../../../../components/buttons/Button'
import Card from '../../../../components/cards/Card'
import { formatNumberWithCommas } from '../../../../utils/formatters'

import ClientIcon from '../../../../assets/images/svg/client.svg'

import { faClock, faLongArrowAltLeft, faSave } from '@fortawesome/free-solid-svg-icons'
import { Row, Col } from 'react-bootstrap'
import Alert from 'sweetalert-react'

import { selectGetSingleOrder } from '../../../../selectors/orders.selector'
import {
  actionTypes,
  createNewOrder,
  onConfirmOrderVisit,
  updateOrderProducts,
} from '../../../../actions/orders.actions'
import { loadingSelector } from '../../../../selectors/loading.selector'
import {
  hasErrorsSelector,
  singleErrorSelector,
  handlerError,
  handlerSuccess,
} from '../../../../selectors/error.selector'

import { selectCurrentModule } from '../../../../selectors/user.selector'

import { onSetModalOrder } from '../../../../actions/utilities.actions'

import moment from 'moment'
import FormTextField from '../../../../components/inputs/FormTextField/FormTextField'
import {
  selectOrigin,
  selectWarehouseInventory,
} from '../../../../selectors/warehouse.selector'
import { setInventoryList } from '../../../../actions/warehouse.actions'
import { selectContractedProducts } from '../../../../selectors/contracts.selector'

import { isAllowed } from '../../../../selectors/modules.selector'

import CreateSubscription from '../../../Subscription/CreateSubscription'
import Money from '../../../../components/Money/Money'
import { selectCurrentCurrency } from '../../../../selectors/currencies.selector'
import { TableV2 } from '../../../../components'

class OrderResume extends Component {
  state = {
    alert: { show: false, title: 'default' },
    description: null,
    external: false,
    longitude: 0,
    latitude: 0,
    spin: false,
    subscriptionModal: { show: false, amount: 0 },
  }

  componentDidMount() {
    const { inventory, setInventoryList } = this.props
    inventory.map(i => {
      if (i.realQuantity <= 0) i.checked = false
    })
    setInventoryList(inventory)

    const { linked } = this.props.match.params
    if (linked === 'true') this.setState({ external: true })
  }

  componentWillReceiveProps(next) {
    const { loading, hasError, handlerError, handlerSuccess, history } = this.props

    const { error, order } = next

    let { alert } = this.state
    if (loading && !next.loading) {
      if (!hasError && next.hasError) {
        alert = handlerError(
          error.message ? error.message : 'Ha ocurrido un error inesperado.',
        )
        alert.onConfirm = () => this.setState({ alert: { ...alert, show: false } })
      } else {
        alert = handlerSuccess(`La orden ${order.number} fue creada satisfactoriamente.`)
        alert.onConfirm = () => {
          this.setState({ alert: { ...alert, show: false } })
          history.goBack()
          setTimeout(() => {
            //todo
            this.props.getSingleOrder(order.id)
          }, 500)
        }
      }
    }

    const { loadingVisit, hasErrorVisit } = this.props
    const { errorVisit, visitResponse } = next

    if (loadingVisit && !next.loadingVisit) {
      if (!hasErrorVisit && next.hasErrorVisit) {
        alert = handlerError(errorVisit.message)
        alert.onConfirm = () => this.setState({ alert: { ...alert, show: false } })
      } else {
        this.setState({ alert: { ...alert, show: false } })
        history.goBack()
        setTimeout(() => {
          this.props.getSingleOrder(visitResponse)
        }, 500)

        /*alert = handlerSuccess(`La orden de visita fue confirmada satisfactoriamente.`);
                alert.onConfirm = () => {
                    this.setState({alert: {...alert, show: false}});
                    history.goBack();
                    setTimeout(() => {
                        this.props.getSingleOrder(order.id);
                    }, 500);
                }*/
      }
    }

    const { loadingU, hasErrorU } = this.props
    const { errorU } = next

    if (loadingU && !next.loadingU) {
      if (!hasErrorU && next.hasErrorU) {
        alert = handlerError(errorU.message || 'Ha ocurrido un error inesperado.')
        alert.onConfirm = () => this.setState({ alert: { ...alert, show: false } })
      } else {
        alert = handlerSuccess(
          `La orden ${order.number} fue actualizada satisfactoriamente.`,
        )
        alert.onConfirm = () => {
          this.setState({ alert: { ...alert, show: false } })
          history.goBack()
          setTimeout(() => {
            this.props.getSingleOrder(order.id)
          }, 500)
        }
      }
    }

    this.setState({ alert })
  }

  goTo = order => {
    const { module, history } = this.props
    let route = ''
    if (module === 1000) route = `/distribucion/ordenes/false/detalle/${order.id}`
    else if (module === 2000) route = `/produccion/ordenes/false/detalle/${order.id}`
    history.replace(route)
  }

  totalProductDetail = () => {
    const { inventory } = this.props
    let total = 0
    inventory
      .filter(i => i.checked)
      .map(i => {
        // total += (parseFloat(i.realQuantity) * i.productPrice) - i.discount;
        total += parseFloat(i.subTotal)
      })
    return formatNumberWithCommas(total)
  }

  getHeaders = () => {
    return [
      {
        label: 'SKU',
        show: true,
        value: ['codeC'],
        type: 'text',
        className: 'mini',
        custom: item => (item.codeC = item.productCode || item.code),
      },
      {
        label: 'Nombre',
        show: true,
        value: ['nameC'],
        type: 'text',
        className: 'medium',
        custom: item => (item.nameC = item.productName || item.name),
      },
      {
        label: 'Descripón',
        show: true,
        value: ['commentary'],
        type: 'text',
        className: 'medium',
        custom: item => item.commentary || 'Sin descripción',
      },
      {
        label: 'Precio',
        show: true,
        value: ['priceC'],
        type: 'text',
        className: 'medium',
        custom: item => (item.priceC = item.productPrice || item.price),
      },
      {
        label: 'Cantidad',
        show: true,
        value: ['cantidadC'],
        type: 'text',
        className: 'mini',
        custom: item => (item.cantidadC = item.quantity + ',' + item.sQuantity),
      },
      {
        label: 'Descuento',
        show: true,
        value: ['discount'],
        type: 'currency',
        className: 'mini',
      },
      {
        label: 'Total',
        show: true,
        value: ['subTotal'],
        type: 'currency',
        className: 'mini',
      },
      { config: true, show: true, label: '', className: 'mini center' },
    ]
  }

  showPosition = position => {
    this.setState({
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
    })
  }

  refresh = () => {
    navigator.geolocation.getCurrentPosition(this.showPosition)
  }

  validateOrder = subscription => {
    const {
      order,
      createOrder,
      confirmVisit,
      module,
      inventory,
      origin,
      updateOrderProducts,
    } = this.props
    const { description, external } = this.state
    let { longitude, latitude } = this.state

    let { client, paymentType, warehouse } = order

    let items = []
    inventory.map(product => {
      const {
        productId,
        realQuantity,
        discount,
        purchase,
        origin,
        commentary,
        saleRecipe,
      } = product
      let editable = 1
      if (order.id && order.details) {
        const detail = order.details.find(d => d.product.id === productId)
        if (detail == null) editable = 3
        else if (product.checked) editable = 1
        else editable = 2
      }

      const item = {
        product: productId,
        quantity: saleRecipe ? `${product.quantity}.${product.sQuantity}` : realQuantity,
        discount,
        purchase: purchase ? purchase.value : null,
        origin,
        editable,
        commentary,
      }

      if (product.checked) items.push(item)
      else if (item.editable === 2) items.push(item)
    })

    this.setState({
      alert: {
        type: 'info',
        show: true,
        title: `Crear orden al ${paymentType.label}`,
        text: external ? paymentType.extence : paymentType.description,
        showCancelButton: true,
        onCancel: () => {
          this.setState({ alert: { ...this.state.alert, show: false } })
        },
        onConfirm: () => {
          this.setState({ alert: { ...this.state.alert, show: false } })
          if (order.id) {
            if (order.type === 1) {
              updateOrderProducts(order.id, items)
            } else if (order.type === 2)
              confirmVisit(
                order.id,
                {
                  productDetail: items,
                  client: client.id,
                  paymentType: paymentType.value,
                  warehouse: warehouse.value,
                  deliveryDate: moment(order.deliveryDate).valueOf(),
                  presale: order.presale,
                  description: description,
                },
                module,
              )
          } else {
            longitude = client.longitude || -90.55
            latitude = client.latitude || 14.55
            const request = {
              productDetail: items,
              client: client.id,
              paymentType: paymentType.value,
              warehouse: warehouse.value,
              presale: order.presale,
              deliveryDate: moment(order.deliveryDate).valueOf(),
              description,
              delivered: order.delivered ? order.delivered.value : 0,
              origin,
              name: client.newClient ? client.label : order.name,
              nit: client.nit,
              address: client.address,
              latitude,
              longitude,
              newClient: !!client.newClient,
              delivererCompany: order.delivererCompany
                ? order.delivererCompany.value
                : null,
              linked: external,
              subscription,
            }
            createOrder(request)
          }
        },
      },
    })
  }

  handleInputChange = event => {
    const { name, value } = event.target
    this.setState({ [name]: value })
  }

  render() {
    this.refresh()

    const { order, loading, inventory, match, loadingU, subscription, currentCurrency } =
      this.props
    const { client, global } = order
    const { alert, external } = this.state

    const { params } = match

    const date = moment(order.deliveryDate).format('LL')

    return (
      <div>
        <Row>
          <Col xl={4} lg={4} md={4} sm={114.2} xs={12}>
            <Row>
              <Col xl={12} md={12}>
                <div className={'custom-card'}>
                  <Row style={{ justifyContent: 'center' }}>
                    <img
                      src={client.picture || ClientIcon}
                      alt={'client profile'}
                      className={'picture-client'}
                    />
                  </Row>
                  <Row style={{ justifyContent: 'center' }}>
                    <span className={'client-name'}>
                      {client.companyName || 'desconocido'}
                    </span>
                  </Row>
                  <hr />
                  <Row className={'flex-container space-between'}>
                    <Col xs={4} className={'label'}>
                      Código
                    </Col>
                    <Col className={'description'}>{client.code || 'desconocido'}</Col>
                  </Row>
                  <Row className={'flex-container space-between'}>
                    <Col xs={4} className={'label'}>
                      Teléfono
                    </Col>
                    <Col className={'description'}>{client.phone || 'desconocido'}</Col>
                  </Row>
                  <Row className={'flex-container space-between'}>
                    <Col xs={4} className={'label'}>
                      Dirección
                    </Col>
                    <Col className={'description'}>{client.address || 'desconocido'}</Col>
                  </Row>
                  <Row className={'flex-container space-between'}>
                    <Col xs={4} className={'label'}>
                      NIT
                    </Col>
                    <Col className={'description'}>{client.nit || 'desconocido'}</Col>
                  </Row>
                </div>
              </Col>
              <Col xl={12} md={12}>
                <br />
                <div className={'custom-card'}>
                  <Row style={{ justifyContent: 'center' }}>
                    <span className={'client-name'}>
                      {order.paymentType ? order.paymentType.label : 'desconocido'}
                    </span>
                  </Row>
                  <Row className={'flex-container space-between'}>
                    <Col className={'description center'}>
                      {order.paymentType
                        ? external
                          ? order.paymentType.extence
                          : order.paymentType.description
                        : 'desconocido'}
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Col>
          <Col xl={8} lg={8} md={8} sm={12} xs={12}>
            <Card title={'Productos en la orden'}>
              <TableV2
                items={inventory.filter(i => i.checked)}
                headers={this.getHeaders()}
                mobileAuto
                storageKey={`orderResume`}
              />

              <hr />
              {inventory && inventory.filter(i => i.checked).length > 0 ? (
                <div>
                  <Money component="h3">
                    Total Orden: <b>{this.totalProductDetail()}</b>
                  </Money>
                </div>
              ) : (
                ''
              )}
              {order.presale ? (
                <h2 style={{ color: 'red' }}>*Eligió productos sin existencias</h2>
              ) : (
                ''
              )}
              <br />
              <Row>
                <FormTextField
                  label={'Descripcion'}
                  type={'text'}
                  id={'description'}
                  placeholder={'Descripcion'}
                  name={'description'}
                  value={this.state.description}
                  onChange={this.handleInputChange}
                />
              </Row>
            </Card>
          </Col>
        </Row>

        <Alert {...alert} />

        <hr />
        <Row className={'container-buttons'}>
          <Button
            color={'secondary'}
            disabled={loading || loadingU}
            onClick={() => {
              if (params.id && params.sale) this.props.jumpToStep(0)
              else this.props.jumpToStep(1)
            }}
            icon={faLongArrowAltLeft}
          />
          {subscription && (
            <Button
              icon={faClock}
              color={'accent'}
              disabled={loading || loadingU}
              onClick={() =>
                this.setState({
                  subscriptionModal: {
                    show: true,
                    amount: this.totalProductDetail(),
                  },
                })
              }>
              Crear suscripción
            </Button>
          )}
          <Button
            color={'primary'}
            loading={loading || loadingU || this.props.loadingVisit}
            onClick={() => this.validateOrder()}
            icon={faSave}>
            Crear para: {date}
          </Button>
        </Row>

        <CreateSubscription
          show={this.state.subscriptionModal.show}
          modal
          amount={this.state.subscriptionModal.amount}
          onHide={() => this.setState({ subscriptionModal: { show: false, amount: 0 } })}
          type={1}
          onCreate={data => {
            if (global) data.ownerType = 2
            else data.ownerType = 1
            this.validateOrder({ ...data, startDate: data.startDate.valueOf() })
          }}
        />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  order: selectGetSingleOrder(state),
  module: selectCurrentModule(state),
  loading: loadingSelector([actionTypes.CREATE_NEW_ORDER])(state),
  hasError: hasErrorsSelector([actionTypes.CREATE_NEW_ORDER])(state),
  error: singleErrorSelector([actionTypes.CREATE_NEW_ORDER])(state),
  loadingVisit: loadingSelector([actionTypes.ON_CONFIRM_VISIT_ORDER])(state),
  hasErrorVisit: hasErrorsSelector([actionTypes.ON_CONFIRM_VISIT_ORDER])(state),
  errorVisit: singleErrorSelector([actionTypes.ON_CONFIRM_VISIT_ORDER])(state),
  handlerSuccess: message => handlerSuccess(message),
  handlerError: message => handlerError(message),
  inventory: selectWarehouseInventory(state),
  origin: selectOrigin(state),
  loadingU: loadingSelector([actionTypes.UPDATE_PRODUCTS_ORDER])(state),
  hasErrorU: hasErrorsSelector([actionTypes.UPDATE_PRODUCTS_ORDER])(state),
  errorU: singleErrorSelector([actionTypes.UPDATE_PRODUCTS_ORDER])(state),
  contractedProducts: selectContractedProducts(state),
  subscription: isAllowed(state, [1122, 2822]),
  visitResponse: state.orders.visitResponse,
  currentCurrency: selectCurrentCurrency(state),
})

const mapDispatchToProps = dispatch => ({
  setInventoryList: list => dispatch(setInventoryList(list)),
  confirmVisit: (visit, sale, module) =>
    dispatch(onConfirmOrderVisit(visit, sale, module)),
  createOrder: request => dispatch(createNewOrder(request)),
  updateOrderProducts: (orderId, products) =>
    dispatch(updateOrderProducts(orderId, { productDetail: products })),
  getSingleOrder: id => dispatch(onSetModalOrder(id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(OrderResume)
